import { fetch } from '../request';
import type { IResponse, ShareParams, PiecesShareParams } from '../interface';

// 分享（单个/批量）
export const share = (body?: ShareParams) => {
  return fetch<IResponse>('/youyan/my_share/share/', {
    method: 'POST',
    body,
  });
};

// 成片外部分享
export const piecesShare = (body?: PiecesShareParams) => {
  return fetch<IResponse>('/youyan/my_share/share_for_out/', {
    method: 'POST',
    body,
    autoErrorHandle: false,
  });
};
